import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import BottomNav from '../BottomNav/BottomNav';
import './PageContainer.css';

const PageContainer = ({ 
  children, 
  title = '', 
  showBack = false, 
  showHeader = true,
  showBottomNav = true,
  className = '' 
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="page-wrapper">
      {showHeader && (
        <Header title={title} showBack={showBack} onBack={handleBack} />
      )}
      <main className={`page-container ${className}`}>
        <div className="page-content">
          {children}
        </div>
      </main>
      {showBottomNav && <BottomNav />}
    </div>
  );
};

export default PageContainer;
